import { Close, Search } from '@mui/icons-material'
import { T, useTranslate } from '@tolgee/react'
import { useState } from 'react'
import { CheckBox, Input, Microbutton } from 'ui'

export function DatabasesModal({ documentContext, closeModal }) {
  const { t } = useTranslate()

  const [initialSelection, setInitialSelection] = useState(documentContext.databases)
  const [filter, setFilter] = useState('')

  const handleCloseModal = (e) => {
    e.stopPropagation()
    e.target === e.currentTarget && closeModal()
  }

  if (!documentContext.isModalVisible) return

  const renderDatabase = (db) => (
    <label
      htmlFor={db.id}
      key={db.id}
      className='hover:bg-brand-violet/10 group relative flex min-h-[40px] items-center gap-x-[10px] rounded-[4px] bg-white py-2 pl-3 pr-2 transition-all duration-300 sm:min-h-[32px]'
    >
      <CheckBox
        containerClasses='self-start mt-[3px]'
        id={db.id}
        checkBoxValue={documentContext.databases.some((item) => item.id === db.id)}
        setChecked={({ checked }) => {
          if (!checked) {
            documentContext.removeDatabase(db.id)
          } else {
            documentContext.addDatabase({
              id: db.id,
              name: db.name,
              descriptionKeyName: db.descriptionKeyName,
            })
          }
        }}
      />

      <div>
        <div className='truncate font-medium'>{db.name}</div>
        <div className='text-[12px] opacity-80'>
          <T keyName={db.descriptionKeyName}>{db.descriptionKeyName}</T>
        </div>
      </div>
    </label>
  )

  const selectedDatabases = documentContext.databases
  const availableDatabases = documentContext.availableDatabases.filter(
    (item) =>
      !documentContext.databases.some((db) => db.id === item.id) &&
      item.name.toLowerCase().includes(filter)
  )

  return (
    <div
      className='fixed bottom-0 left-0 right-0 top-0 z-[99999] bg-white/80'
      onClick={handleCloseModal}
    >
      <div className='xs:border absolute left-1/2 top-1/2 flex h-[min(600px,95dvh)] w-[min(500px,95vw)] -translate-x-1/2 -translate-y-1/2 flex-col rounded-[4px] border-[#D9D9D9] bg-white shadow-[0_0_20px_#00000020]'>
        {/* Header */}
        <div className='bg-brand-violet space-y-1 rounded-t-[3px] pb-[24px] pl-[24px] pr-[16px] pt-[14px] text-white'>
          <div className='flex items-center justify-between'>
            <div className='text-[14px] font-medium'>
              {t('eleo-database-modal-title', 'Add external database')}
            </div>
            <Microbutton
              variant='plain'
              icon={<Close fontSize='inherit' />}
              onClick={() => closeModal()}
              className='size-[28px] hover:bg-white/10'
            />
          </div>

          <div className='text-[12px] leading-[1.3em] text-white/70'>
            {t(
              'eleo-database-modal-info',
              'Using databases may induce additional charges. Some databases will consider your question multiple times to determine the best answer'
            )}
          </div>

          <div className=' relative !mt-[30px] flex w-full items-center'>
            <Input
              className='body-secondary text-brand-violet flex-1 font-medium placeholder:font-light'
              placeholder={t('eleo-db-search-placeholder', 'Search in databases...')}
              value={filter}
              onChange={setFilter}
            />
            <Search
              className='text-brand-violet pointer-events-none absolute right-2'
              fontSize='small'
            />
          </div>
        </div>

        {/* Content */}
        <div className='text-brand-violet xs:px-[26px] flex-1 overflow-y-auto px-4 pb-3 pt-5 text-[13px]'>
          {selectedDatabases.map((db) => renderDatabase(db))}

          {selectedDatabases.length && availableDatabases?.length ? (
            <div className='mx-2 my-[6px] border-b' />
          ) : null}

          {availableDatabases?.map((db) => renderDatabase(db))}
        </div>

        {/* Footer */}
        <div className='border-b ' />
        <div className='flex gap-[14px] px-[24px] py-[14px] text-[13px] capitalize'>
          <button
            type='button'
            className='bg-brand-violet/10 hover:bg-brand-violet/20 hover:text-brand-violet text-brand-violet-light h-[40px] w-full rounded-[4px] font-bold uppercase transition-colors'
            onClick={() => {
              documentContext.setDatabases(initialSelection)
              closeModal()
            }}
          >
            {t('eleo-modal-cancel-button', 'Cancel')}
          </button>
          <button
            type='button'
            className='bg-brand-violet hover:bg-brand-violet-light h-[40px] w-full rounded-[4px] font-bold uppercase text-white transition-colors'
            onClick={() => closeModal()}
          >
            {t('eleo-modal-accept-button', 'Accept')}
          </button>
        </div>
      </div>
    </div>
  )
}
